var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isAnyFilterActive)?_c('router-link',{staticClass:"c-reset-filters__btn",attrs:{"to":_vm.buildResetQuery}},[_vm._v("\n  "+_vm._s(_vm.getProductOverviewTranslations['ProductsOverview.ResetFilters'])+"\n  "),_c('i',{staticClass:"far fa-times ml-2"})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }